























































































































































































import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import LoadingMixin, { Status } from '@spa/mixins/loading'

import BehaviorConfig from '@/models/app-config/behavior/behavior'

import { PluginMixin } from '@spa/mixins/plugin'
import { User } from '@spa/store/modules/user/types'
import { UserValidator } from '@spa/validation/user'

import SpaCharacter from '@/components/organisms/Character.vue'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { Gender } from '@/util/gender'
import PrefectureSelect from '@spa/components/organisms/PrefectureSelectBox.vue'
import AddressForm from '@spa/components/organisms/profile/AddressForm.vue'
import { AddressFormState } from '@spa/components/organisms/profile/addressFormState'
import BirthdayForm from '@spa/components/organisms/profile/BirthdayForm.vue'
import { BirthdayFormState } from '@spa/components/organisms/profile/birthdayFormState'
import GenderForm from '@spa/components/organisms/profile/GenderForm.vue'
import NameForm from '@spa/components/organisms/profile/NameForm.vue'
import { NameFormState } from '@spa/components/organisms/profile/nameFormState'
import PhoneticNameForm from '@spa/components/organisms/profile/PhoneticNameForm.vue'
import { PhoneticNameFormState } from '@spa/components/organisms/profile/phoneticNameFormState'
import TelForm from '@spa/components/organisms/profile/TelForm.vue'
import { AddressFieldsEnabledState } from '@spa/components/pages/mypage/edit/contact/interaction'

import Fade from '@spa/components/atoms/transition/Fade.vue'

@Component({
  components: {
    SpaCharacter,
    PrefectureSelect,
    SpaErrorDialog,
    TelForm,
    NameForm,
    PhoneticNameForm,
    AddressForm,
    GenderForm,
    BirthdayForm,
    Fade,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class AddProfile extends Mixins<PluginMixin>(PluginMixin) {
  pageStatus: Status = Status.Pending

  submitStatus: Status = Status.Pending

  validator: UserValidator = new UserValidator()

  firstName?: string = ''

  lastName?: string = ''

  phoneticFirstName?: string = ''

  phoneticLastName?: string = ''

  tel?: string = ''

  year?: number | null = null

  month?: number | null = null

  day?: number | null = null

  gender?: Gender | null = null

  zipcode?: string = ''

  prefecture?: string = ''

  city?: string = ''

  town?: string = ''

  addressFieldsEnabledState: AddressFieldsEnabledState =
     AddressFieldsEnabledState.init({})

  showModal: boolean = false

  modalMessage: string = ''

  behaviorConfig = new BehaviorConfig()

  get user(): User {
    return this.$store.state.user.user
  }

  get fillMemberInfoStatus(): boolean {
    return this.$store.getters['user/getFillMemberInfo']
  }

  get isLoading(): boolean {
    return this.pageStatus === Status.Loading
  }

  get isPageCompleted(): boolean {
    return this.pageStatus === Status.Completed
  }

  get isSubmitLoading(): boolean {
    return this.submitStatus === Status.Loading
  }

  get isSubmitCompleted(): boolean {
    return this.submitStatus === Status.Completed
  }

  get isSubmitFailed(): boolean {
    return this.submitStatus === Status.Failed
  }

  get errorOnLoad() {
    return _.get(this.$store.state.user, 'error.load')
  }

  get errorOnUpdate() {
    return _.get(this.$store.state.user, 'error.update')
  }

  get isRegisteredBirthday() {
    return !!this.user.birthday
  }

  get isRegisteredGender() {
    return !!this.user.gender
  }

  get hasErrorOnAddressTelSet(): boolean {
    return !this.validator.validateIsSetAddressAndTel(
      this.zipcode,
      this.prefecture,
      this.city,
      this.town,
      this.tel
    )
  }

  get hasErrorOnNameSet(): boolean {
    return !this.validator.validateIsSetUserNameAndKana(
      this.lastName,
      this.firstName,
      this.phoneticLastName,
      this.phoneticFirstName
    )
  }

  get hasErrorOnBirthdayValidation(): boolean {
    return !this.validator.validateBirthday(
      this.year,
      this.month,
      this.day
    )
  }

  async created() {
    this.pageStatus = Status.Loading

    await this.initOrElseRedirectUser()

    this.setInitialFieldValues(this.user)

    this.pageStatus = Status.Completed
  }

  enableAddressFields() {
    this.addressFieldsEnabledState =
      this.addressFieldsEnabledState.searchedAddress()
  }

  async submit() {
    const formValidated = await this.validateForm()

    if (!formValidated ||
        this.hasErrorOnBirthdayValidation ||
        this.hasErrorOnNameSet ||
        this.hasErrorOnAddressTelSet) {

      this.modalMessage = '入力内容が正しくありません'
      this.showModal = true

      return
    }

    this.registerNewProfileData()
  }

  async registerNewProfileData(): Promise<void> {

    this.submitStatus = Status.Loading

    const payload = this.makeUserPayload()

    await this.$store.dispatch('user/update', payload)

    if (this.errorOnUpdate) {
      this.submitStatus = Status.Failed

      return
    }

    this.submitStatus = Status.Completed

    this.scrollToTop()
  }

  async initOrElseRedirectUser(): Promise<void> {

    // Load User
    await this.$store.dispatch('user/get', { force: true })

    const user = this.$store.state.user.user

    if (!user) {
      this.modalMessage = 'ログインできませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true
      this.$router.push('/login')

      return
    }

    // other
    if (this.errorOnLoad) {
      this.modalMessage = 'お客様情報が取得できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true
      this.pageStatus = Status.Failed

      return
    }

  }

  handleTelFormUpdated(val: string): void {
    this.tel = val
  }

  handleNameFormUpdated(val: NameFormState): void {
    const { firstName, lastName } = val

    this.firstName = firstName
    this.lastName = lastName
  }

  handlePhoneticNameFormUpdated(val: PhoneticNameFormState): void {
    const { phoneticFirstName, phoneticLastName } = val

    this.phoneticFirstName = phoneticFirstName
    this.phoneticLastName = phoneticLastName
  }

  handleBirthdayFormUpdated(val: BirthdayFormState): void {
    const { year, month, day } = val

    this.year = year
    this.month = month
    this.day = day
  }

  handleGenderFormUpdated(val: Gender | null): void {
    this.gender = val
  }

  handleAddressFormUpdated(val: AddressFormState): void {
    const { zipcode, prefectureCode, city, town } = val

    this.zipcode = zipcode
    this.prefecture = prefectureCode
    this.city = city
    this.town = town
  }

  // NOTE: #8671 一度登録された氏名項目（姓、名、姓カナ、名カナ）を削除できてしまう問題がある
  // ただし、カラット関連機能（運用停止中）のため修正不要
  private setInitialFieldValues(user: User): void {
    this.firstName = user.first_name
    this.lastName = user.last_name
    this.phoneticFirstName = user.phonetic_first_name
    this.phoneticLastName = user.phonetic_last_name
    this.tel = user.tel

    const { year, month, day } = user.birthday ?
      this.splitBirthday(user.birthday) : { year: undefined, month: undefined, day: undefined }

    this.year = year
    this.month = month
    this.day = day
    this.gender = Gender[Gender[user.gender]]
    this.zipcode = user.zipcode
    this.prefecture = user.region
    this.city = user.address1
    this.town = user.address2
    this.addressFieldsEnabledState = AddressFieldsEnabledState.init({
      zipcode: this.zipcode,
      prefectureCode: this.prefecture,
      city: this.city,
      town: this.town,
    })
  }

  private splitBirthday(birthday: string): { year: number, month: number, day: number } {
    const list = (birthday || '').split('-')

    return {
      year: Number(_.get(list, 0)),
      month: Number(_.get(list, 1)),
      // tslint:disable-next-line:no-magic-numbers
      day: Number(_.get(list, 2)),
    }
  }

  private async validateForm(): Promise<boolean> {
    // To force to validate untouched fields
    this.$validator.fields.map((field) => {
      this.$validator.flag(field.name, {
        touched: true,
      })
    })

    return this.$validator.validateAll()
  }

  private makeUserPayload(): object {
    return {
      first_name: this.firstName,
      last_name: this.lastName,
      tel: this.tel,
      phonetic_first_name: this.phoneticFirstName,
      phonetic_last_name: this.phoneticLastName,
      gender: this.gender,
      birthday: this.year ? `${this.year}-${this.month}-${this.day}` : undefined,
      zipcode: this.zipcode,
      region: this.prefecture,
      address1: this.city,
      address2: this.town,
    }
  }

  scrollToTop() {
    const scrolled = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
    // tslint:disable-next-line
    window.scrollTo(0, Math.floor(scrolled / 2))
    if (scrolled > 0) {
      // tslint:disable-next-line
      window.setTimeout(this.scrollToTop, 30);
    }
  }
}
